import { NSARouterMakerResult } from "namirasoft-account-react";
import { ObjectService } from "namirasoft-core";
import { EntityType, RunRow } from "namirasoft-expert";
import { NSBox, NSBoxEntity, NSButtonBlue, NSColumn, NSTitle } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { useParams } from "react-router-dom";
import { ExpertLayout } from "../ExpertLayout";
import { ExpertRouterProps } from "../ExpertRouterProps";
import { ExpertRoutes } from "../ExpertRoutes";
import { InfraEntity, listInfraEntities } from "../listInfraEntities";

interface AgentTestPageInnerProps extends NSARouterMakerResult, ExpertRouterProps
{
    agent_id: string;
    entity_type: EntityType;
}

interface AgentTestPageInnerState
{
    submitting: boolean;
}

export class AgentTestPageInner extends Component<AgentTestPageInnerProps, AgentTestPageInnerState>
{
    public static async RunTest(props: NSARouterMakerResult & ExpertRouterProps, agent_id: string, entity_type: EntityType, entity_id: string): Promise<void>
    {
        debugger;
        const { id } = await props.servers.expert.test.Generate(agent_id, entity_type, entity_id, { message_user: null });
        const run: RunRow = await props.servers.expert.run.Get(id);
        if (!run.chat_id)
            throw new Error("Generated run has no chat_id");
        props.url.redirect(ExpertRoutes.Chat_Test(agent_id, run.chat_id), {});
    }
    private NSBoxEntity_EntityID = createRef<NSBoxEntity<InfraEntity>>();

    constructor(props: AgentTestPageInnerProps)
    {
        super(props);
        this.state = { submitting: false };
    }

    private async onGenerate(onFinished: () => void)
    {
        try
        {
            const entity_id = this.NSBoxEntity_EntityID.current?.getValueOne(true);
            if (!entity_id)
                return;
            AgentTestPageInner.RunTest(this.props, this.props.agent_id, this.props.entity_type, entity_id);
        }
        catch (error)
        {
            this.props.notifier.onError(error as Error);
        }
        finally
        {
            this.setState({ submitting: false });
        }
        onFinished();
    }

    override render()
    {
        return (
            <ExpertLayout
                {...this.props}
                action={{ title: `Agent Test - ${this.props.entity_type}` }}
            >
                <NSColumn classList={["align-items-center"]}>
                    <NSTitle
                        title={`Test ${this.props.entity_type}`}
                        style={{ fontSize: "1.5rem", margin: 0 }}
                    />

                    <NSBoxEntity<InfraEntity>
                        ref={this.NSBoxEntity_EntityID}
                        title={`${this.props.entity_type}`}
                        required={true}
                        multiple={false}
                        table_name={this.props.entity_type.toLowerCase()}
                        list={async (filters, page, size, sorts) =>
                        {
                            return await listInfraEntities(
                                this.props.servers.infra,
                                this.props.entity_type,
                                filters,
                                page,
                                size,
                                sorts,
                            );
                        }}
                        getValue={(item) => item.id}
                        getTitle={(item) => item.name}
                        getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    {
                        <NSButtonBlue
                            title={"Start"}
                            onClick={{
                                showLoading: true,
                                action: (onFinished) => this.onGenerate(onFinished)
                            }}
                        />
                    }
                </NSColumn>
            </ExpertLayout>
        );
    }
}

interface AgentTestPageProps extends NSARouterMakerResult, ExpertRouterProps { }

function AgentTestPage(props: AgentTestPageProps)
{
    const params = useParams();
    const agent_id = params["id"] ?? "";
    const entity_type_param = params["entity_type"] ?? "";
    const entity_type = new ObjectService(entity_type_param).getEnum(EntityType, EntityType.Cache);

    return (
        <AgentTestPageInner
            {...props}
            agent_id={agent_id}
            entity_type={entity_type}
        />
    );
}

export default AgentTestPage;